export default __webpack_public_path__ + "static/media/Mikas.f87957e4.jpg";